/**
 * @generated SignedSource<<f8724c34422f2ff1f813cd4ebef13605>>
 * @relayHash 8bf09bc41e5043061a41253bc832b42a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bf09bc41e5043061a41253bc832b42a

import type { ConcreteRequest } from 'relay-runtime';
export type CodeScanningSecurityAlertStatus = "DISMISSED" | "FIXED" | "OPEN" | "%future added value";
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type IssueFieldVisibility = "ALL" | "ORG_ONLY" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
export type IssueViewerSubscriptionMetadataSubscription$variables = {
  issueId: string;
};
export type IssueViewerSubscriptionMetadataSubscription$data = {
  readonly issueUpdated: {
    readonly commentReactionUpdated: {
      readonly reactionGroups: ReadonlyArray<{
        readonly content: ReactionContent;
        readonly reactors: {
          readonly nodes: ReadonlyArray<{
            readonly __typename: string;
            readonly avatarUrl?: string;
            readonly displayName?: string;
            readonly isAgent?: boolean;
            readonly isCopilot?: boolean;
            readonly login?: string;
            readonly name?: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number;
        };
        readonly viewerHasReacted: boolean;
      }> | null | undefined;
    } | null | undefined;
    readonly commentUpdated: {
      readonly author: {
        readonly avatarUrl: string;
        readonly id: string;
        readonly login: string;
        readonly name?: string | null | undefined;
      } | null | undefined;
      readonly authorAssociation: CommentAuthorAssociation;
      readonly authorToRepoOwnerSponsorship: {
        readonly createdAt: string;
        readonly isActive: boolean;
      } | null | undefined;
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly createdAt: string;
      readonly createdViaEmail: boolean;
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly isHidden: boolean;
      readonly issue: {
        readonly author: {
          readonly login: string;
        } | null | undefined;
        readonly databaseId: number | null | undefined;
        readonly id: string;
        readonly number: number;
        readonly pinnedIssueComment: {
          readonly issueComment: {
            readonly author: {
              readonly avatarUrl: string;
              readonly login: string;
              readonly profileUrl: string | null | undefined;
            } | null | undefined;
            readonly createdAt: string;
            readonly id: string;
            readonly shortBodyHTML: string;
            readonly url: string;
            readonly viewerCanUnpin: boolean;
          };
          readonly pinnedBy: {
            readonly login: string;
          };
        } | null | undefined;
      };
      readonly lastEditedAt: string | null | undefined;
      readonly lastUserContentEdit: {
        readonly editor: {
          readonly login: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined;
      readonly minimizedReason: string | null | undefined;
      readonly pendingBlock: boolean | null | undefined;
      readonly pendingMinimizeReason: string | null | undefined;
      readonly pendingUnblock: boolean | null | undefined;
      readonly pinnedBy: {
        readonly login: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
        readonly owner: {
          readonly id: string;
          readonly login: string;
          readonly url: string;
        };
      };
      readonly showSpammyBadge: boolean;
      readonly url: string;
      readonly viaApp: {
        readonly name: string;
        readonly url: string;
      } | null | undefined;
      readonly viewerCanBlockFromOrg: boolean;
      readonly viewerCanBlockPersonally: boolean;
      readonly viewerCanDelete: boolean;
      readonly viewerCanMinimize: boolean;
      readonly viewerCanPin: boolean;
      readonly viewerCanReadUserContentEdits: boolean;
      readonly viewerCanReport: boolean;
      readonly viewerCanReportToMaintainer: boolean;
      readonly viewerCanUnblockFromOrg: boolean;
      readonly viewerCanUnblockPersonally: boolean;
      readonly viewerCanUnminimize: boolean;
      readonly viewerCanUnpin: boolean;
      readonly viewerCanUpdate: boolean;
      readonly viewerDidAuthor: boolean;
    } | null | undefined;
    readonly deletedCommentId: string | null | undefined;
    readonly issue: {
      readonly number: number;
      readonly repository: {
        readonly name: string;
        readonly owner: {
          readonly login: string;
        };
      };
    };
    readonly issueBodyUpdated: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
    } | null | undefined;
    readonly issueDependenciesSummaryUpdated: {
      readonly blockedBy: {
        readonly nodes: ReadonlyArray<{
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
      };
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly issueDependenciesSummary: {
        readonly blockedBy: number;
        readonly blocking: number;
      };
      readonly parent: {
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly nameWithOwner: string;
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly subIssuesSummary: {
          readonly completed: number;
          readonly total: number;
        };
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined;
      readonly repository: {
        readonly isArchived: boolean;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly securityAlerts: {
        readonly nodes: ReadonlyArray<{
          readonly number: number | null | undefined;
          readonly repository: {
            readonly nameWithOwner: string;
          } | null | undefined;
          readonly status: CodeScanningSecurityAlertStatus | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly state: IssueState;
      readonly topBlockedBy: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly topBlocking: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly topRelatesTo: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
        readonly totalCount: number;
      };
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
    readonly issueFieldsUpdated: {
      readonly id: string;
      readonly issueFieldValues: {
        readonly nodes: ReadonlyArray<{
          readonly color?: IssueFieldSingleSelectOptionColor;
          readonly description?: string | null | undefined;
          readonly field?: {
            readonly dataType?: IssueFieldDataType;
            readonly id?: string;
            readonly name?: string;
            readonly visibility?: IssueFieldVisibility;
          } | null | undefined;
          readonly multiSelectValue?: string | null | undefined;
          readonly name?: string;
          readonly numberValue?: number;
          readonly optionId?: string | null | undefined;
          readonly options?: ReadonlyArray<{
            readonly color: IssueFieldSingleSelectOptionColor;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
          }>;
          readonly value?: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly issueType: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly viewerCanSetFields: boolean | null | undefined;
    } | null | undefined;
    readonly issueMetadataUpdated: {
      readonly agentAssignments: ReadonlyArray<{
        readonly assignee: {
          readonly avatarUrl: string;
          readonly displayName: string;
          readonly id: string;
          readonly isAgent: boolean;
          readonly isCopilot: boolean;
          readonly login: string;
        } | null | undefined;
        readonly assigner: {
          readonly __typename: string;
          readonly id?: string;
          readonly login: string;
        } | null | undefined;
      }>;
      readonly assignedActors: {
        readonly nodes: ReadonlyArray<{
          readonly __typename?: string;
          readonly avatarUrl?: string;
          readonly displayName?: string;
          readonly id?: string;
          readonly isAgent?: boolean;
          readonly isCopilot?: boolean;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly closedByPullRequestsReferences: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "PullRequest";
          readonly createdAt: string;
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly __typename: string;
              readonly id: string;
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly title: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly labels: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly color: string;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly nameHTML: string;
            readonly url: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      } | null | undefined;
      readonly linkedBranches: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly ref: {
            readonly __typename: "Ref";
            readonly associatedPullRequests: {
              readonly totalCount: number;
            };
            readonly id: string;
            readonly name: string;
            readonly repository: {
              readonly defaultBranchRef: {
                readonly associatedPullRequests: {
                  readonly totalCount: number;
                };
                readonly id: string;
                readonly name: string;
                readonly target: {
                  readonly id: string;
                  readonly oid: any;
                } | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly nameWithOwner: string;
            };
            readonly target: {
              readonly id: string;
              readonly oid: any;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly linkedPullRequestReleases: {
        readonly nodes: ReadonlyArray<{
          readonly pullRequest: {
            readonly id: string;
          } | null | undefined;
          readonly release: {
            readonly id: string;
            readonly isLatest: boolean;
            readonly isPrerelease: boolean;
            readonly name: string | null | undefined;
            readonly tagName: string;
            readonly url: string;
          };
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly linkedPullRequests: {
        readonly nodes: ReadonlyArray<{
          readonly isDraft: boolean;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly url: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly milestone: {
        readonly closed: boolean;
        readonly closedAt: string | null | undefined;
        readonly dueOn: string | null | undefined;
        readonly id: string;
        readonly progressPercentage: number;
        readonly title: string;
        readonly url: string;
      } | null | undefined;
      readonly number: number;
      readonly projectItems: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fieldValueByName: {
              readonly color?: ProjectV2SingleSelectFieldOptionColor;
              readonly id?: string;
              readonly name?: string | null | undefined;
              readonly nameHTML?: string | null | undefined;
              readonly optionId?: string | null | undefined;
            } | null | undefined;
            readonly id: string;
            readonly isArchived: boolean;
            readonly project: {
              readonly closed: boolean;
              readonly field: {
                readonly databaseId?: number | null | undefined;
                readonly id?: string;
                readonly name?: string;
                readonly options?: ReadonlyArray<{
                  readonly color: ProjectV2SingleSelectFieldOptionColor;
                  readonly description: string;
                  readonly descriptionHTML: string;
                  readonly id: string;
                  readonly name: string;
                  readonly nameHTML: string;
                  readonly optionId: string;
                }>;
              } | null | undefined;
              readonly hasReachedItemsLimit: boolean;
              readonly id: string;
              readonly number: number;
              readonly template: boolean;
              readonly title: string;
              readonly url: string;
              readonly viewerCanUpdate: boolean;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly repository: {
        readonly databaseId: number | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly title: string;
      readonly viewerCanLinkBranches: boolean;
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
    readonly issueReactionUpdated: {
      readonly reactionGroups: ReadonlyArray<{
        readonly content: ReactionContent;
        readonly reactors: {
          readonly nodes: ReadonlyArray<{
            readonly __typename: string;
            readonly avatarUrl?: string;
            readonly displayName?: string;
            readonly isAgent?: boolean;
            readonly isCopilot?: boolean;
            readonly login?: string;
            readonly name?: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number;
        };
        readonly viewerHasReacted: boolean;
      }> | null | undefined;
    } | null | undefined;
    readonly issueStateUpdated: {
      readonly duplicateOf: {
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly url: string;
      } | null | undefined;
      readonly id: string;
      readonly repository: {
        readonly id: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
    } | null | undefined;
    readonly issueTitleUpdated: {
      readonly agentAssignments: ReadonlyArray<{
        readonly __typename: "AgentAssignment";
      }>;
      readonly assignedActors: {
        readonly nodes: ReadonlyArray<{
          readonly __typename?: string;
          readonly avatarUrl?: string;
          readonly displayName?: string;
          readonly id?: string;
          readonly isAgent?: boolean;
          readonly isCopilot?: boolean;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly closedByPullRequestsReferences: {
        readonly nodes: ReadonlyArray<{
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly number: number;
          readonly state: PullRequestState;
          readonly url: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly duplicateOf: {
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly url: string;
      } | null | undefined;
      readonly id: string;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
      readonly labels: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly color: string;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly nameHTML: string;
            readonly url: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      } | null | undefined;
      readonly linkedPullRequests: {
        readonly nodes: ReadonlyArray<{
          readonly isDraft: boolean;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly url: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly milestone: {
        readonly closed: boolean;
        readonly closedAt: string | null | undefined;
        readonly dueOn: string | null | undefined;
        readonly id: string;
        readonly progressPercentage: number;
        readonly title: string;
        readonly url: string;
      } | null | undefined;
      readonly number: number;
      readonly repository: {
        readonly id: string;
        readonly isArchived: boolean;
        readonly isPrivate: boolean;
        readonly isWritable: boolean;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly subIssuesSummary: {
        readonly completed: number;
        readonly total: number;
      };
      readonly title: string;
      readonly titleHTML: string;
      readonly url: string;
      readonly viewerCanUpdateNext: boolean | null | undefined;
    } | null | undefined;
    readonly issueTransferStateUpdated: {
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly isArchived: boolean;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
        readonly viewerCanPush: boolean;
        readonly visibility: RepositoryVisibility;
      };
      readonly subIssues: {
        readonly nodes: ReadonlyArray<{
          readonly assignees: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly avatarUrl: string;
                readonly id: string;
                readonly login: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
            readonly totalCount: number;
          };
          readonly closed: boolean;
          readonly closedByPullRequestsReferences: {
            readonly totalCount: number;
          } | null | undefined;
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly issueDependenciesSummary: {
            readonly blockedBy: number;
          };
          readonly issueType: {
            readonly color: IssueTypeColor;
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly subIssuesSummary: {
            readonly completed: number;
            readonly total: number;
          };
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
      };
      readonly subIssuesConnection: {
        readonly totalCount: number;
      };
      readonly subIssuesSummary: {
        readonly total: number;
      };
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
    readonly issueTypeUpdated: {
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly isEnabled: boolean;
        readonly name: string;
        readonly pinnedFields: ReadonlyArray<{
          readonly __typename: "IssueFieldDate";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldNumber";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldSingleSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          readonly __typename: "IssueFieldText";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        }> | null | undefined;
      } | null | undefined;
      readonly repository: {
        readonly nameWithOwner: string;
      };
    } | null | undefined;
    readonly parentIssueUpdated: {
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly issueDependenciesSummary: {
        readonly blockedBy: number;
        readonly blocking: number;
      };
      readonly parent: {
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly subIssuesSummary: {
          readonly completed: number;
          readonly total: number;
        };
        readonly title: string;
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined;
      readonly repository: {
        readonly isArchived: boolean;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly securityAlerts: {
        readonly nodes: ReadonlyArray<{
          readonly number: number | null | undefined;
          readonly repository: {
            readonly nameWithOwner: string;
          } | null | undefined;
          readonly status: CodeScanningSecurityAlertStatus | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly topBlockedBy: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly topBlocking: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly topRelatesTo: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
        readonly totalCount: number;
      };
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
    readonly pinnedCommentUpdated: {
      readonly author: {
        readonly id: string;
        readonly login: string;
        readonly name?: string | null | undefined;
      } | null | undefined;
      readonly authorAssociation: CommentAuthorAssociation;
      readonly authorToRepoOwnerSponsorship: {
        readonly createdAt: string;
        readonly isActive: boolean;
      } | null | undefined;
      readonly body: string;
      readonly createdAt: string;
      readonly createdViaEmail: boolean;
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly isHidden: boolean;
      readonly issue: {
        readonly id: string;
        readonly number: number;
        readonly pinnedIssueComment: {
          readonly issueComment: {
            readonly author: {
              readonly avatarUrl: string;
              readonly login: string;
              readonly profileUrl: string | null | undefined;
            } | null | undefined;
            readonly createdAt: string;
            readonly id: string;
            readonly shortBodyHTML: string;
            readonly url: string;
            readonly viewerCanUnpin: boolean;
          };
          readonly pinnedBy: {
            readonly login: string;
          };
        } | null | undefined;
      };
      readonly lastEditedAt: string | null | undefined;
      readonly lastUserContentEdit: {
        readonly editor: {
          readonly login: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined;
      readonly minimizedReason: string | null | undefined;
      readonly pendingBlock: boolean | null | undefined;
      readonly pendingMinimizeReason: string | null | undefined;
      readonly pendingUnblock: boolean | null | undefined;
      readonly pinnedBy: {
        readonly login: string;
      } | null | undefined;
      readonly repository: {
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
        readonly owner: {
          readonly id: string;
          readonly login: string;
          readonly url: string;
        };
      };
      readonly showSpammyBadge: boolean;
      readonly url: string;
      readonly viaApp: {
        readonly name: string;
        readonly url: string;
      } | null | undefined;
      readonly viewerCanBlockFromOrg: boolean;
      readonly viewerCanBlockPersonally: boolean;
      readonly viewerCanDelete: boolean;
      readonly viewerCanMinimize: boolean;
      readonly viewerCanPin: boolean;
      readonly viewerCanReadUserContentEdits: boolean;
      readonly viewerCanReport: boolean;
      readonly viewerCanReportToMaintainer: boolean;
      readonly viewerCanUnblockFromOrg: boolean;
      readonly viewerCanUnblockPersonally: boolean;
      readonly viewerCanUnminimize: boolean;
      readonly viewerCanUnpin: boolean;
      readonly viewerCanUpdate: boolean;
      readonly viewerDidAuthor: boolean;
    } | null | undefined;
    readonly subIssuesSummaryUpdated: {
      readonly subIssuesSummary: {
        readonly completed: number;
        readonly total: number;
      };
    } | null | undefined;
    readonly subIssuesUpdated: {
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly number: number;
      readonly parent: {
        readonly id: string;
      } | null | undefined;
      readonly repository: {
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
        readonly viewerCanPush: boolean;
        readonly visibility: RepositoryVisibility;
      };
      readonly subIssues: {
        readonly nodes: ReadonlyArray<{
          readonly assignees: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly avatarUrl: string;
                readonly id: string;
                readonly login: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
            readonly totalCount: number;
          };
          readonly closed: boolean;
          readonly closedByPullRequestsReferences: {
            readonly totalCount: number;
          } | null | undefined;
          readonly databaseId: number | null | undefined;
          readonly id: string;
          readonly issueDependenciesSummary: {
            readonly blockedBy: number;
          };
          readonly issueType: {
            readonly color: IssueTypeColor;
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly subIssuesSummary: {
            readonly completed: number;
            readonly total: number;
          };
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
      };
      readonly subIssuesConnection: {
        readonly totalCount: number;
      };
      readonly subIssuesSummary: {
        readonly total: number;
      };
    } | null | undefined;
  };
};
export type IssueViewerSubscriptionMetadataSubscription = {
  response: IssueViewerSubscriptionMetadataSubscription$data;
  variables: IssueViewerSubscriptionMetadataSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedCommentId",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": [
    (v9/*: any*/),
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": {
        "direction": "ASC",
        "field": "NAME"
      }
    }
  ],
  "concreteType": "LabelConnection",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            (v3/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Milestone",
  "kind": "LinkedField",
  "name": "milestone",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressPercentage",
      "storageKey": null
    },
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "kind": "Literal",
  "name": "allowSameEnterprise",
  "value": true
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    (v24/*: any*/),
    (v3/*: any*/),
    (v14/*: any*/),
    (v13/*: any*/)
  ],
  "type": "ProjectV2ItemFieldSingleSelectValue",
  "abstractKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasReachedItemsLimit",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v29/*: any*/),
    (v12/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2SingleSelectFieldOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v24/*: any*/),
        (v3/*: any*/),
        (v14/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "descriptionHTML",
          "storageKey": null
        },
        (v15/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2SingleSelectField",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdateMetadata",
  "storageKey": null
},
v35 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v36 = [
  (v35/*: any*/),
  {
    "kind": "Literal",
    "name": "includeClosedPrs",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "orderByState",
    "value": true
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v37/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v41 = {
  "alias": "linkedPullRequests",
  "args": (v36/*: any*/),
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v38/*: any*/),
        (v16/*: any*/),
        (v2/*: any*/),
        (v39/*: any*/),
        (v40/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
},
v42 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v49 = {
  "alias": null,
  "args": (v42/*: any*/),
  "concreteType": "AssigneeConnection",
  "kind": "LinkedField",
  "name": "assignedActors",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v31/*: any*/),
            (v12/*: any*/),
            (v4/*: any*/),
            (v3/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/),
            (v48/*: any*/)
          ],
          "type": "Actor",
          "abstractKey": "__isActor"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "assignedActors(first:20)"
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Bot",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v4/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/)
  ],
  "storageKey": null
},
v51 = [
  (v12/*: any*/)
],
v52 = {
  "kind": "InlineFragment",
  "selections": (v51/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v53 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v54 = [
  (v53/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v58 = [
  (v57/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "associatedPullRequests",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v60 = {
  "kind": "Literal",
  "name": "includeClosedPrs",
  "value": true
},
v61 = [
  (v35/*: any*/),
  (v60/*: any*/)
],
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": (v61/*: any*/),
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v16/*: any*/),
        (v2/*: any*/),
        (v18/*: any*/),
        (v39/*: any*/),
        (v40/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInMergeQueue",
          "storageKey": null
        },
        (v62/*: any*/),
        (v29/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v3/*: any*/),
            (v37/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                (v4/*: any*/),
                (v31/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v31/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
},
v64 = [
  (v35/*: any*/)
],
v65 = {
  "alias": null,
  "args": (v64/*: any*/),
  "concreteType": "LinkedPullRequestReleaseConnection",
  "kind": "LinkedField",
  "name": "linkedPullRequestReleases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkedPullRequestRelease",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PullRequest",
          "kind": "LinkedField",
          "name": "pullRequest",
          "plural": false,
          "selections": (v51/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Release",
          "kind": "LinkedField",
          "name": "release",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tagName",
              "storageKey": null
            },
            (v3/*: any*/),
            (v16/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPrerelease",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLatest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "linkedPullRequestReleases(first:10)"
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanLinkBranches",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdateNext",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWritable",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "SubIssuesSummary",
  "kind": "LinkedField",
  "name": "subIssuesSummary",
  "plural": false,
  "selections": [
    (v74/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "duplicateOf",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v16/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "AgentAssignment",
  "kind": "LinkedField",
  "name": "agentAssignments",
  "plural": true,
  "selections": [
    (v31/*: any*/)
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": (v61/*: any*/),
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v2/*: any*/),
        (v16/*: any*/),
        (v39/*: any*/),
        (v29/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v37/*: any*/)
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v83 = [
  (v12/*: any*/),
  (v3/*: any*/),
  (v82/*: any*/)
],
v84 = {
  "kind": "InlineFragment",
  "selections": (v83/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": (v83/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": (v83/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v87 = {
  "kind": "InlineFragment",
  "selections": (v83/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasReacted",
  "storageKey": null
},
v90 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    (v44/*: any*/),
    (v48/*: any*/)
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
},
v92 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ReactionGroup",
    "kind": "LinkedField",
    "name": "reactionGroups",
    "plural": true,
    "selections": [
      (v88/*: any*/),
      (v89/*: any*/),
      {
        "alias": null,
        "args": (v90/*: any*/),
        "concreteType": "ReactorConnection",
        "kind": "LinkedField",
        "name": "reactors",
        "plural": false,
        "selections": [
          (v57/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v31/*: any*/),
              (v91/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "reactors(first:5)"
      }
    ],
    "storageKey": null
  }
],
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v94 = [
  (v12/*: any*/),
  (v3/*: any*/),
  (v82/*: any*/),
  (v93/*: any*/)
],
v95 = {
  "kind": "InlineFragment",
  "selections": (v94/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v97 = {
  "kind": "InlineFragment",
  "selections": (v94/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v98 = {
  "kind": "InlineFragment",
  "selections": (v94/*: any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldSingleSelectOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v3/*: any*/),
    (v13/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v100 = {
  "alias": "multiSelectValue",
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v101 = {
  "kind": "InlineFragment",
  "selections": (v94/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v102 = {
  "kind": "InlineFragment",
  "selections": (v94/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v103 = {
  "alias": "numberValue",
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanSetFields",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorAssociation",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanMinimize",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnminimize",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReport",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReportToMaintainer",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockFromOrg",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockFromOrg",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockPersonally",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockPersonally",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPin",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "App",
  "kind": "LinkedField",
  "name": "viaApp",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v119 = {
  "alias": "isHidden",
  "args": null,
  "kind": "ScalarField",
  "name": "isMinimized",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimizedReason",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSpammyBadge",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdViaEmail",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsorship",
  "kind": "LinkedField",
  "name": "authorToRepoOwnerSponsorship",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v124/*: any*/)
  ],
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReadUserContentEdits",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastEditedAt",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "UserContentEdit",
  "kind": "LinkedField",
  "name": "lastUserContentEdit",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "editor",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "pinnedBy",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v131 = [
  (v3/*: any*/)
],
v132 = {
  "kind": "InlineFragment",
  "selections": (v131/*: any*/),
  "type": "User",
  "abstractKey": null
},
v133 = {
  "kind": "InlineFragment",
  "selections": (v131/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v134 = {
  "kind": "InlineFragment",
  "selections": (v131/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v4/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    (v72/*: any*/)
  ],
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 700
    },
    {
      "kind": "Literal",
      "name": "stripBlockElements",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "shortBodyHTML",
  "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
},
v137 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "concreteType": "PinnedIssueComment",
  "kind": "LinkedField",
  "name": "pinnedIssueComment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pinnedBy",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueComment",
      "kind": "LinkedField",
      "name": "issueComment",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v136/*: any*/),
        (v62/*: any*/),
        (v16/*: any*/),
        (v117/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v130/*: any*/),
            (v137/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v139 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingMinimizeReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingBlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingUnblock",
      "storageKey": null
    }
  ]
},
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPush",
  "storageKey": null
},
v141 = {
  "alias": "subIssuesConnection",
  "args": null,
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "subIssues",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v142 = [
  (v9/*: any*/)
],
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockedBy",
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueDependenciesSummary",
  "kind": "LinkedField",
  "name": "issueDependenciesSummary",
  "plural": false,
  "selections": [
    (v143/*: any*/)
  ],
  "storageKey": null
},
v145 = {
  "alias": null,
  "args": (v64/*: any*/),
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "assignees",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v4/*: any*/),
            (v130/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "assignees(first:10)"
},
v146 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v3/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 0
    },
    (v60/*: any*/)
  ],
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": "closedByPullRequestsReferences(first:0,includeClosedPrs:true)"
},
v148 = {
  "alias": null,
  "args": (v142/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "subIssues",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v19/*: any*/),
        (v39/*: any*/),
        (v76/*: any*/),
        (v144/*: any*/),
        (v145/*: any*/),
        (v16/*: any*/),
        (v7/*: any*/),
        (v29/*: any*/),
        (v2/*: any*/),
        (v18/*: any*/),
        (v70/*: any*/),
        (v146/*: any*/),
        (v75/*: any*/),
        (v147/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "subIssues(first:100)"
},
v149 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v150 = {
  "alias": null,
  "args": null,
  "concreteType": "SubIssuesSummary",
  "kind": "LinkedField",
  "name": "subIssuesSummary",
  "plural": false,
  "selections": [
    (v74/*: any*/)
  ],
  "storageKey": null
},
v151 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v22/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v152 = {
  "kind": "Literal",
  "name": "ranked",
  "value": true
},
v153 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  (v152/*: any*/)
],
v154 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "nodes",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v18/*: any*/),
    (v70/*: any*/),
    (v16/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v37/*: any*/),
        (v3/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v39/*: any*/),
    (v76/*: any*/)
  ],
  "storageKey": null
},
v155 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v10/*: any*/)
  ],
  "storageKey": null
},
v156 = [
  (v154/*: any*/),
  (v155/*: any*/)
],
v157 = {
  "alias": "topBlockedBy",
  "args": (v153/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blockedBy",
  "plural": false,
  "selections": (v156/*: any*/),
  "storageKey": "blockedBy(first:3,ranked:true)"
},
v158 = {
  "alias": "topBlocking",
  "args": (v153/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blocking",
  "plural": false,
  "selections": (v156/*: any*/),
  "storageKey": "blocking(first:3,ranked:true)"
},
v159 = {
  "alias": "topRelatesTo",
  "args": (v153/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "relatesTo",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v154/*: any*/),
    (v155/*: any*/)
  ],
  "storageKey": "relatesTo(first:3,ranked:true)"
},
v160 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": (v142/*: any*/),
  "concreteType": "CodeScanningSecurityAlertConnection",
  "kind": "LinkedField",
  "name": "securityAlerts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeScanningSecurityAlert",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v80/*: any*/),
        (v160/*: any*/),
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "securityAlerts(first:100)"
},
v162 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueDependenciesSummary",
  "kind": "LinkedField",
  "name": "issueDependenciesSummary",
  "plural": false,
  "selections": [
    (v143/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocking",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v163 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  (v152/*: any*/)
],
v164 = [
  (v31/*: any*/),
  (v4/*: any*/),
  (v12/*: any*/)
],
v165 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v164/*: any*/),
  "storageKey": null
},
v166 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v165/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v167 = [
  (v21/*: any*/),
  (v53/*: any*/)
],
v168 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v37/*: any*/),
    (v165/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v169 = {
  "alias": "linkedPullRequests",
  "args": (v36/*: any*/),
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v168/*: any*/),
        (v16/*: any*/),
        (v2/*: any*/),
        (v39/*: any*/),
        (v40/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
},
v170 = {
  "alias": null,
  "args": (v42/*: any*/),
  "concreteType": "AssigneeConnection",
  "kind": "LinkedField",
  "name": "assignedActors",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v31/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*: any*/),
            (v4/*: any*/),
            (v3/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/),
            (v48/*: any*/)
          ],
          "type": "Actor",
          "abstractKey": "__isActor"
        },
        (v52/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "assignedActors(first:20)"
},
v171 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v55/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v172 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "duplicateOf",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v16/*: any*/),
    (v166/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v173 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v174 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ReactionGroup",
    "kind": "LinkedField",
    "name": "reactionGroups",
    "plural": true,
    "selections": [
      (v88/*: any*/),
      (v89/*: any*/),
      {
        "alias": null,
        "args": (v90/*: any*/),
        "concreteType": "ReactorConnection",
        "kind": "LinkedField",
        "name": "reactors",
        "plural": false,
        "selections": [
          (v57/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v31/*: any*/),
              (v91/*: any*/),
              (v52/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "reactors(first:5)"
      }
    ],
    "storageKey": null
  },
  (v12/*: any*/)
],
v175 = {
  "alias": null,
  "args": null,
  "concreteType": "App",
  "kind": "LinkedField",
  "name": "viaApp",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v16/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v176 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsorship",
  "kind": "LinkedField",
  "name": "authorToRepoOwnerSponsorship",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v124/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v177 = {
  "alias": null,
  "args": null,
  "concreteType": "UserContentEdit",
  "kind": "LinkedField",
  "name": "lastUserContentEdit",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "editor",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v16/*: any*/),
        (v4/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v178 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "pinnedBy",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v179 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v12/*: any*/),
        (v4/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    (v72/*: any*/)
  ],
  "storageKey": null
},
v180 = {
  "alias": null,
  "args": null,
  "concreteType": "PinnedIssueComment",
  "kind": "LinkedField",
  "name": "pinnedIssueComment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pinnedBy",
      "plural": false,
      "selections": (v164/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueComment",
      "kind": "LinkedField",
      "name": "issueComment",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v136/*: any*/),
        (v62/*: any*/),
        (v16/*: any*/),
        (v117/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v4/*: any*/),
            (v130/*: any*/),
            (v137/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v181 = {
  "alias": null,
  "args": (v142/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "subIssues",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v19/*: any*/),
        (v39/*: any*/),
        (v76/*: any*/),
        (v144/*: any*/),
        (v145/*: any*/),
        (v16/*: any*/),
        (v166/*: any*/),
        (v29/*: any*/),
        (v2/*: any*/),
        (v18/*: any*/),
        (v70/*: any*/),
        (v146/*: any*/),
        (v75/*: any*/),
        (v147/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "subIssues(first:100)"
},
v182 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v22/*: any*/),
    (v165/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v183 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "nodes",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v18/*: any*/),
    (v70/*: any*/),
    (v16/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v37/*: any*/),
        (v3/*: any*/),
        (v165/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    (v39/*: any*/),
    (v76/*: any*/)
  ],
  "storageKey": null
},
v184 = [
  (v183/*: any*/),
  (v155/*: any*/)
],
v185 = {
  "alias": "topBlockedBy",
  "args": (v153/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blockedBy",
  "plural": false,
  "selections": (v184/*: any*/),
  "storageKey": "blockedBy(first:3,ranked:true)"
},
v186 = {
  "alias": "topBlocking",
  "args": (v153/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blocking",
  "plural": false,
  "selections": (v184/*: any*/),
  "storageKey": "blocking(first:3,ranked:true)"
},
v187 = {
  "alias": "topRelatesTo",
  "args": (v153/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "relatesTo",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v183/*: any*/),
    (v155/*: any*/)
  ],
  "storageKey": "relatesTo(first:3,ranked:true)"
},
v188 = {
  "alias": null,
  "args": (v142/*: any*/),
  "concreteType": "CodeScanningSecurityAlertConnection",
  "kind": "LinkedField",
  "name": "securityAlerts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeScanningSecurityAlert",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v173/*: any*/),
        (v160/*: any*/),
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "securityAlerts(first:100)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerSubscriptionMetadataSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueMetadataUpdated",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v20/*: any*/),
              {
                "alias": "projectItems",
                "args": [
                  (v21/*: any*/)
                ],
                "concreteType": "ProjectV2ItemConnection",
                "kind": "LinkedField",
                "name": "__ProjectSection_projectItems_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectV2Item",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "fieldValueByName",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/)
                            ],
                            "storageKey": "fieldValueByName(name:\"Status\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectV2",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v2/*: any*/),
                              (v16/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": (v23/*: any*/),
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/)
                                ],
                                "storageKey": "field(name:\"Status\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": "__ProjectSection_projectItems_connection(allowSameEnterprise:true)"
              },
              (v34/*: any*/),
              (v41/*: any*/),
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assigner",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v52/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v29/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              (v18/*: any*/),
              (v2/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": (v54/*: any*/),
                "concreteType": "LinkedBranchConnection",
                "kind": "LinkedField",
                "name": "linkedBranches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkedBranch",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Ref",
                        "kind": "LinkedField",
                        "name": "ref",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v12/*: any*/),
                          (v31/*: any*/),
                          (v56/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ref",
                                "kind": "LinkedField",
                                "name": "defaultBranchRef",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v12/*: any*/),
                                  (v56/*: any*/),
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "linkedBranches(first:25)"
              },
              (v63/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueBodyUpdated",
            "plural": false,
            "selections": [
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTitleUpdated",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v70/*: any*/),
              (v2/*: any*/),
              (v16/*: any*/),
              (v71/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v37/*: any*/),
                  (v6/*: any*/),
                  (v22/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v75/*: any*/),
              (v39/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v41/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v17/*: any*/),
              (v20/*: any*/),
              (v49/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueStateUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v39/*: any*/),
              (v76/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v37/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v77/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTypeUpdated",
            "plural": false,
            "selections": [
              (v80/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v81/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      (v84/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      (v87/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueReactionUpdated",
            "plural": false,
            "selections": (v92/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueFieldsUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": (v54/*: any*/),
                "concreteType": "IssueFieldValueConnection",
                "kind": "LinkedField",
                "name": "issueFieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v95/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v96/*: any*/)
                        ],
                        "type": "IssueFieldTextValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v97/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          (v3/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/)
                        ],
                        "type": "IssueFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v98/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v99/*: any*/),
                          (v100/*: any*/)
                        ],
                        "type": "IssueFieldMultiSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v101/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v96/*: any*/)
                        ],
                        "type": "IssueFieldDateValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v102/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v103/*: any*/)
                        ],
                        "type": "IssueFieldNumberValue",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "issueFieldValues(first:25)"
              },
              (v104/*: any*/),
              (v105/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentReactionUpdated",
            "plural": false,
            "selections": (v92/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v29/*: any*/),
              (v16/*: any*/),
              (v62/*: any*/),
              (v106/*: any*/),
              (v27/*: any*/),
              (v107/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v116/*: any*/),
              (v117/*: any*/),
              (v118/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v125/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v128/*: any*/),
              (v129/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v130/*: any*/),
                  (v132/*: any*/),
                  (v133/*: any*/),
                  (v134/*: any*/)
                ],
                "storageKey": null
              },
              (v135/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v138/*: any*/)
                ],
                "storageKey": null
              },
              (v139/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "pinnedCommentUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v29/*: any*/),
              (v16/*: any*/),
              (v62/*: any*/),
              (v67/*: any*/),
              (v106/*: any*/),
              (v27/*: any*/),
              (v107/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v116/*: any*/),
              (v117/*: any*/),
              (v118/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v125/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v132/*: any*/),
                  (v133/*: any*/),
                  (v134/*: any*/)
                ],
                "storageKey": null
              },
              (v135/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v128/*: any*/),
              (v129/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v138/*: any*/)
                ],
                "storageKey": null
              },
              (v139/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "subIssuesUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v37/*: any*/),
                  (v93/*: any*/),
                  (v140/*: any*/)
                ],
                "storageKey": null
              },
              (v141/*: any*/),
              (v148/*: any*/),
              (v29/*: any*/),
              (v2/*: any*/),
              (v149/*: any*/),
              (v150/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTransferStateUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v37/*: any*/),
                  (v22/*: any*/),
                  (v93/*: any*/),
                  (v140/*: any*/)
                ],
                "storageKey": null
              },
              (v141/*: any*/),
              (v148/*: any*/),
              (v29/*: any*/),
              (v2/*: any*/),
              (v34/*: any*/),
              (v149/*: any*/),
              (v150/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "subIssuesSummaryUpdated",
            "plural": false,
            "selections": [
              (v75/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "parentIssueUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v29/*: any*/),
              (v34/*: any*/),
              (v151/*: any*/),
              (v157/*: any*/),
              (v158/*: any*/),
              (v159/*: any*/),
              (v161/*: any*/),
              (v162/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v76/*: any*/),
                  (v18/*: any*/),
                  (v70/*: any*/),
                  (v16/*: any*/),
                  (v75/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueDependenciesSummaryUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v29/*: any*/),
              (v34/*: any*/),
              (v151/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v70/*: any*/),
                  (v16/*: any*/),
                  (v2/*: any*/),
                  (v80/*: any*/),
                  (v39/*: any*/),
                  (v76/*: any*/),
                  (v75/*: any*/)
                ],
                "storageKey": null
              },
              (v157/*: any*/),
              (v158/*: any*/),
              (v159/*: any*/),
              (v161/*: any*/),
              (v39/*: any*/),
              (v162/*: any*/),
              {
                "alias": null,
                "args": (v163/*: any*/),
                "concreteType": "IssueConnection",
                "kind": "LinkedField",
                "name": "blockedBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Issue",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v70/*: any*/),
                      (v2/*: any*/),
                      (v16/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "blockedBy(first:1,ranked:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "EventSubscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueViewerSubscriptionMetadataSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v166/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedCommentId"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueMetadataUpdated",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v167/*: any*/),
                "concreteType": "ProjectV2ItemConnection",
                "kind": "LinkedField",
                "name": "projectItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2ItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectV2Item",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "fieldValueByName",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v25/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": "fieldValueByName(name:\"Status\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectV2",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v2/*: any*/),
                              (v16/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": (v23/*: any*/),
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  (v30/*: any*/),
                                  (v52/*: any*/)
                                ],
                                "storageKey": "field(name:\"Status\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": "projectItems(allowSameEnterprise:true,first:25)"
              },
              {
                "alias": null,
                "args": (v167/*: any*/),
                "filters": [
                  "allowSameEnterprise"
                ],
                "handle": "connection",
                "key": "ProjectSection_projectItems",
                "kind": "LinkedHandle",
                "name": "projectItems"
              },
              (v34/*: any*/),
              (v169/*: any*/),
              (v170/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assigner",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isActor"
                      },
                      (v4/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v29/*: any*/),
                  (v3/*: any*/),
                  (v165/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              (v18/*: any*/),
              (v2/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": (v54/*: any*/),
                "concreteType": "LinkedBranchConnection",
                "kind": "LinkedField",
                "name": "linkedBranches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkedBranch",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Ref",
                        "kind": "LinkedField",
                        "name": "ref",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v12/*: any*/),
                          (v31/*: any*/),
                          (v171/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ref",
                                "kind": "LinkedField",
                                "name": "defaultBranchRef",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v12/*: any*/),
                                  (v171/*: any*/),
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "linkedBranches(first:25)"
              },
              (v63/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueBodyUpdated",
            "plural": false,
            "selections": [
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTitleUpdated",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v70/*: any*/),
              (v2/*: any*/),
              (v16/*: any*/),
              (v71/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v37/*: any*/),
                  (v165/*: any*/),
                  (v22/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v75/*: any*/),
              (v39/*: any*/),
              (v76/*: any*/),
              (v172/*: any*/),
              (v169/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v17/*: any*/),
              (v20/*: any*/),
              (v170/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueStateUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v39/*: any*/),
              (v76/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v37/*: any*/),
                  (v165/*: any*/)
                ],
                "storageKey": null
              },
              (v172/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTypeUpdated",
            "plural": false,
            "selections": [
              (v173/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v81/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      (v84/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      (v87/*: any*/),
                      (v52/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueReactionUpdated",
            "plural": false,
            "selections": (v174/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueFieldsUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": (v54/*: any*/),
                "concreteType": "IssueFieldValueConnection",
                "kind": "LinkedField",
                "name": "issueFieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v95/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v96/*: any*/)
                        ],
                        "type": "IssueFieldTextValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v97/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          (v3/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/)
                        ],
                        "type": "IssueFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v98/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v99/*: any*/),
                          (v100/*: any*/)
                        ],
                        "type": "IssueFieldMultiSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v101/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v96/*: any*/)
                        ],
                        "type": "IssueFieldDateValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v102/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v103/*: any*/)
                        ],
                        "type": "IssueFieldNumberValue",
                        "abstractKey": null
                      },
                      (v52/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "issueFieldValues(first:25)"
              },
              (v104/*: any*/),
              (v105/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentReactionUpdated",
            "plural": false,
            "selections": (v174/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v29/*: any*/),
              (v16/*: any*/),
              (v62/*: any*/),
              (v106/*: any*/),
              (v27/*: any*/),
              (v107/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v116/*: any*/),
              (v117/*: any*/),
              (v175/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v176/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v177/*: any*/),
              (v178/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v130/*: any*/),
                  (v132/*: any*/),
                  (v133/*: any*/),
                  (v134/*: any*/)
                ],
                "storageKey": null
              },
              (v179/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v164/*: any*/),
                    "storageKey": null
                  },
                  (v180/*: any*/)
                ],
                "storageKey": null
              },
              (v139/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "pinnedCommentUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v29/*: any*/),
              (v16/*: any*/),
              (v62/*: any*/),
              (v67/*: any*/),
              (v106/*: any*/),
              (v27/*: any*/),
              (v107/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v116/*: any*/),
              (v117/*: any*/),
              (v175/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v176/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v12/*: any*/),
                  (v4/*: any*/),
                  (v132/*: any*/),
                  (v133/*: any*/),
                  (v134/*: any*/)
                ],
                "storageKey": null
              },
              (v179/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v177/*: any*/),
              (v178/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v180/*: any*/)
                ],
                "storageKey": null
              },
              (v139/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "subIssuesUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v165/*: any*/),
                  (v12/*: any*/),
                  (v37/*: any*/),
                  (v93/*: any*/),
                  (v140/*: any*/)
                ],
                "storageKey": null
              },
              (v141/*: any*/),
              (v181/*: any*/),
              (v29/*: any*/),
              (v2/*: any*/),
              (v149/*: any*/),
              (v150/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTransferStateUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v165/*: any*/),
                  (v12/*: any*/),
                  (v37/*: any*/),
                  (v22/*: any*/),
                  (v93/*: any*/),
                  (v140/*: any*/)
                ],
                "storageKey": null
              },
              (v141/*: any*/),
              (v181/*: any*/),
              (v29/*: any*/),
              (v2/*: any*/),
              (v34/*: any*/),
              (v149/*: any*/),
              (v150/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "subIssuesSummaryUpdated",
            "plural": false,
            "selections": [
              (v75/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "parentIssueUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v29/*: any*/),
              (v34/*: any*/),
              (v182/*: any*/),
              (v185/*: any*/),
              (v186/*: any*/),
              (v187/*: any*/),
              (v188/*: any*/),
              (v162/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/),
                  (v168/*: any*/),
                  (v39/*: any*/),
                  (v76/*: any*/),
                  (v18/*: any*/),
                  (v70/*: any*/),
                  (v16/*: any*/),
                  (v75/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueDependenciesSummaryUpdated",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v29/*: any*/),
              (v34/*: any*/),
              (v182/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v70/*: any*/),
                  (v16/*: any*/),
                  (v2/*: any*/),
                  (v173/*: any*/),
                  (v39/*: any*/),
                  (v76/*: any*/),
                  (v75/*: any*/)
                ],
                "storageKey": null
              },
              (v185/*: any*/),
              (v186/*: any*/),
              (v187/*: any*/),
              (v188/*: any*/),
              (v39/*: any*/),
              (v162/*: any*/),
              {
                "alias": null,
                "args": (v163/*: any*/),
                "concreteType": "IssueConnection",
                "kind": "LinkedField",
                "name": "blockedBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Issue",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v70/*: any*/),
                      (v2/*: any*/),
                      (v16/*: any*/),
                      (v166/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "blockedBy(first:1,ranked:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8bf09bc41e5043061a41253bc832b42a",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "issueUpdated",
            "issueMetadataUpdated",
            "projectItems"
          ]
        }
      ]
    },
    "name": "IssueViewerSubscriptionMetadataSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "2f3675961fda28a97e89664263d829a3";

export default node;
